import React from 'react';
import { TopNavigationButtons } from '../TopNavigationButtons';
import { StyledNavigationBar } from './styled';
export function TopNavigationBar() {
    return (<StyledNavigationBar>
      <TopNavigationButtons />
    </StyledNavigationBar>);
}
